import React,{useMemo,useState} from "react";
import {Modal,Checkbox,DatePicker,Button,Alert,Space,Typography} from "antd";
import dayjs from "dayjs";
import axios from "axios";
import {API_BASE,getArn} from "../LedgerResponsive";
const {Text}=Typography;
export default function ReportOptionsModal({open,client,onClose}){
 const fyStart=()=>{const n=dayjs();const y=n.month()>=3?n.year():n.year()-1;return dayjs(`${y}-04-01`);};
 const [sections,setSections]=useState({pan_summary:true,amc_summary:true,scheme_summary:true,transactions:false});
 const [startDate,setStartDate]=useState(fyStart()),[endDate,setEndDate]=useState(dayjs());
 const [asOnDate,setAsOnDate]=useState(dayjs());
 const [submitting,setSubmitting]=useState(false),[error,setError]=useState(""),[submitted,setSubmitted]=useState(false);
 const dateRuleError=useMemo(()=>{
   if(asOnDate&&asOnDate.isAfter(dayjs(),"day"))return "As On Date Cannot be a future date.";
   if(!sections.transactions)return "";
   if(!startDate||!endDate)return "Start Date and End Date are required for Transaction Details.";
   if(startDate.isAfter(endDate,"day"))return "Start Date Cannot be greater than End Date.";
   if(endDate.isBefore(startDate,"day"))return "End Date Cannot be earlier than Start Date.";
   if(endDate.isAfter(asOnDate,"day"))return "End Date Cannot be greater than As On Date.";
   if(asOnDate.isBefore(endDate,"day"))return "As On Date Cannot be earlier than End Date.";
   return "";
 },[sections.transactions,startDate,endDate,asOnDate]);
 const count=useMemo(()=>Object.values(sections).filter(Boolean).length,[sections]);
 const setSec=(k,v)=>{
   if(k==="transactions"&&v){
     const adjustedEnd=endDate.isAfter(asOnDate,"day")?asOnDate:endDate;
     setEndDate(adjustedEnd);
     if(startDate.isAfter(adjustedEnd,"day"))setStartDate(adjustedEnd);
   }
   setSections(s=>({...s,[k]:v}));
 };
 const changeAsOnDate=(v)=>{
   if(!v)return;
   setAsOnDate(v);
   if(sections.transactions){
     const adjustedEnd=endDate.isAfter(v,"day")?v:endDate;
     if(endDate.isAfter(v,"day"))setEndDate(adjustedEnd);
     if(startDate.isAfter(adjustedEnd,"day"))setStartDate(adjustedEnd);
   }
 };
 const generate=async()=>{if(submitting)return;setError("");
  if(!count)return setError("Select at least one report section.");
 if(dateRuleError)return setError(dateRuleError);
  setSubmitting(true);
  try{await axios.post(`${API_BASE}/report_job_start.php`,{arn_no:getArn(),pan:client?.pan||"",sections:{...sections,child_pan_summary:false},as_on_date:asOnDate.format("YYYY-MM-DD"),
   transaction_start_date:sections.transactions?startDate.format("YYYY-MM-DD"):null,
   transaction_end_date:sections.transactions?endDate.format("YYYY-MM-DD"):null},{headers:{"Content-Type":"application/json"}});
   setSubmitted(true);
  }catch(e){setError(e?.response?.data?.message||"Could not submit report request.");}finally{setSubmitting(false);}
 };
 return <Modal open={open} title="Generate Portfolio Report" onCancel={()=>!submitting&&!submitted&&onClose()} closable={!submitting&&!submitted} maskClosable={!submitting&&!submitted} footer={null} width={560} destroyOnClose>
  {submitted ? <div style={{padding:"8px 2px"}}>
   <Alert type="success" showIcon message="Report Request Submitted"
    description={<div>
      <div>Your report request has been submitted successfully and is being prepared in the background.</div>
      <div style={{marginTop:10}}><b>Report कहाँ मिलेगी:</b> Dashboard → Reports → Downloads</div>
      <div style={{marginTop:8}}>Downloads page पर <b>Refresh</b> दबाएँ। Report तैयार होने पर status <b>Ready</b> और <b>Download</b> button दिखाई देगा.</div>
      <div style={{marginTop:8}}>तैयार होने के बाद report <b>24 hours</b> तक download के लिए उपलब्ध रहेगी.</div>
    </div>} />
   <div style={{textAlign:"right",marginTop:18}}><Button type="primary" onClick={()=>{setSubmitted(false);onClose();}}>OK</Button></div>
  </div> : <><div style={{marginBottom:14}}><Text strong>{client?.invester_name||"Client"}</Text><br/><Text type="secondary">PAN: {client?.pan||"-"}</Text></div>
  <Space direction="vertical" size={10} style={{width:"100%"}}>
   {["pan_summary","amc_summary","scheme_summary","transactions"].map((k,i)=><Checkbox key={k} checked={sections[k]} onChange={e=>setSec(k,e.target.checked)}>{["PAN Summary","AMC Summary","Scheme Summary","Transaction Details"][i]}</Checkbox>)}
   {sections.transactions&&<div style={{padding:12,border:"1px solid #d9d9d9",borderRadius:8,background:"#fafafa"}}>
    <Text strong>Transaction Period</Text><div style={{display:"flex",gap:10,marginTop:10}}><DatePicker value={startDate} onChange={v=>v&&setStartDate(v)} status={dateRuleError&&startDate?.isAfter(endDate,"day")?"error":undefined} disabledDate={d=>d&&d.isAfter(endDate,"day")} format="DD-MMM-YYYY" style={{width:"50%"}}/><DatePicker value={endDate} onChange={v=>v&&setEndDate(v)} status={dateRuleError&&(endDate?.isBefore(startDate,"day")||endDate?.isAfter(asOnDate,"day"))?"error":undefined} disabledDate={d=>d&&(d.isBefore(startDate,"day")||d.isAfter(asOnDate,"day"))} format="DD-MMM-YYYY" style={{width:"50%"}}/></div>{dateRuleError&&<div style={{marginTop:7,color:"#ff4d4f",fontSize:12}}>{dateRuleError}</div>}
   </div>}
  </Space>
  <div style={{marginTop:14,padding:12,border:"1px solid #d9d9d9",borderRadius:8,background:"#fafafa"}}>
   <Text strong>As On Date</Text><DatePicker value={asOnDate} onChange={changeAsOnDate} status={dateRuleError&&asOnDate?.isAfter(dayjs(),"day")?"error":undefined} disabledDate={d=>d&&d.isAfter(dayjs(),"day")} format="DD-MMM-YYYY" style={{width:"100%",marginTop:8}}/>
   <div style={{marginTop:6}}><Text type="secondary">Report will use the latest available portfolio data on or before the selected date.</Text></div>
  </div>
  {error&&<Alert style={{marginTop:14}} type="error" message={error} showIcon/>}
  <div style={{textAlign:"right",marginTop:20}}><Button onClick={onClose} disabled={submitting} style={{marginRight:8}}>Cancel</Button><Button type="primary" loading={submitting} onClick={generate}>Generate Report</Button></div>
 </>}
 </Modal>;
}